import React from 'react';
import { Badge } from '@lognai/synapse-design-system-v2';
import { Tag, X } from '@lognai/synapse-design-system-v2/icons';

/** Deterministic color per label string so the same label always looks the same. */
const PALETTE = [
  'bg-blue-500/15 text-blue-400 border-blue-500/30',
  'bg-green-500/15 text-green-400 border-green-500/30',
  'bg-purple-500/15 text-purple-400 border-purple-500/30',
  'bg-pink-500/15 text-pink-400 border-pink-500/30',
  'bg-cyan-500/15 text-cyan-400 border-cyan-500/30',
  'bg-orange-500/15 text-orange-400 border-orange-500/30',
];

const colorFor = (label: string): string => {
  let hash = 0;
  for (let i = 0; i < label.length; i++) hash = (hash * 31 + label.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(hash) % PALETTE.length];
};

export interface LabelChipsProps {
  labels: string[];
  onRemove?: (label: string) => void;
  className?: string;
}

export const LabelChips: React.FC<LabelChipsProps> = ({ labels, onRemove, className }) => {
  if (!labels || labels.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className ?? ''}`}>
      {labels.map((label) => (
        <Badge key={label} variant="outline" className={`gap-1 ${colorFor(label)}`}>
          {/* A tag glyph, so a label is distinguishable at a glance from the
              status and priority pills beside it. Those carry meaning the
              system assigns; a label is whatever someone typed, and four
              similar pills in a row said nothing about which was which
              (QA ledger TASK-007). */}
          <Tag className="h-3 w-3" />
          {label}
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(label)}
              aria-label={`Remove ${label}`}
              className="ml-0.5 hover:opacity-70"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </Badge>
      ))}
    </div>
  );
};
